import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import type { AppDispatch, RootState } from 'store';
import { PaginateOperationTypesActions as PaginateActions } from 'store/ducks/operationTypes';
import { usePaginationCache } from 'hooks';
import { Scaffold } from 'layouts';
import {
  TypesList,
  TypeFilters,
  FindOperationTypes,
} from 'components/Pages/OperationTypes';
import { Paginator, ListingPageHeader, SettingsMenu } from 'components/Shared';
import * as S from './styles';

export const OperationTypesListPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();

  const { paginationCache, updatePaginationCache, handleFilter, handleSort } =
    usePaginationCache('operationTypes');

  const {
    data: types,
    pagination,
    loading,
  } = useSelector((state: RootState) => state.paginateOperationTypes);

  const [query, setQuery] = useState<FindOperationTypes>({
    search: '',
    page: 1,
    limit: 10,
    ...paginationCache,
  });

  const onPageChange = useCallback((page: number): void => {
    setQuery((state) => ({ ...state, page }));
  }, []);

  const onQueryChange = useCallback((): void => {
    dispatch(PaginateActions.request(query));
  }, [dispatch, query]);

  useEffect(() => {
    onQueryChange();
  }, [onQueryChange]);

  useEffect(() => {
    return () => {
      dispatch(PaginateActions.reset());
      updatePaginationCache(query);
    };
  }, [dispatch, query, updatePaginationCache]);

  return (
    <Scaffold>
      <SettingsMenu />
      <S.MainPanel>
        <ListingPageHeader
          icon={<S.OperationIcon />}
          title="Tipos de operações"
          isLoading={loading}
        />
        <TypeFilters
          currentFilter={query}
          onFilter={(filter) => handleFilter(query, filter, setQuery)}
        />
        <TypesList
          operationTypes={types}
          onSort={(sort) => handleSort(query, sort, setQuery)}
          currentSort={query}
        />
        <Paginator onPageChange={onPageChange} pagination={pagination} />
      </S.MainPanel>
    </Scaffold>
  );
};
